// extracted by mini-css-extract-plugin
module.exports = {"heroWrapper":"style_heroWrapper__J4g2H","contentWrapper":"style_contentWrapper__M_h9L","heroBreak":"style_heroBreak__FOTr2"};